import { render, staticRenderFns } from "./InspectionApprovalReasonInput.vue?vue&type=template&id=5d642d15&scoped=true&"
import script from "./InspectionApprovalReasonInput.vue?vue&type=script&lang=ts&"
export * from "./InspectionApprovalReasonInput.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionApprovalReasonInput.vue?vue&type=style&index=0&id=5d642d15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d642d15",
  null
  
)

export default component.exports